import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';

import './ImageManagement.css';
import UploadMedia from './UploadMedia/UploadMedia';
import ListMedia from './ListMedia/ListMedia';
import DeleteMedia from './DeleteMedia/DeleteMedia';
import RestoreMedia from '../MaintenanceManagement/RestoreMedia/RestoreMedia';
import AssignCategory from './AssignCategory/AssignCategory';
import ImageViewer from './ImageViewer/ImageViewer'; // Import ImageViewer
import Notification from '../Notification/Notification';
import { fetchMedia, getImageById } from '../../services/mediaService'; // Import the new service


const apiUrl = process.env.REACT_APP_API_URL;

function ImageManagement() {
  const location = useLocation();
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [categories, setCategories] = useState([]);
  const [mediaData, setMediaData] = useState([]); // State to hold media data for ImageViewer
  const [token] = useState(localStorage.getItem('token') || '');
  const [sortOrder, setSortOrder] = useState('newest');
  const [filters, setFilters] = useState({});

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${apiUrl}/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchMediaData = async (imageId = null) => {

    try {
      // 1) Ha nincs imageId → teljes lista jön
      let item = null;
      if (!imageId) {
        try {
          item = await fetchMedia(token, sortOrder, filters);;
        } catch (e) {
          console.warn(`Image ${imageId} not found`);
          // ha nincs ilyen kép, semmit nem módosítunk
          return;
        }

        setMediaData(item);
        return;
      }

      // 2) Ha van imageId → getImageById-t használjuk

      try {
        item = await getImageById(token, imageId);
      } catch (e) {
        console.warn(`Image ${imageId} not found`);
        // ha nincs ilyen kép, semmit nem módosítunk
        return;
      }

      // 3) Frissítés vagy beszúrás a mediaData tömbbe
      setMediaData((prev) => {
        const exists = prev.some((x) => x.id === item.id);

        if (exists) {
          // kicseréljük a meglévőt
          return prev.map((x) => (x.id === item.id ? item : x));
        } else {
          // hozzáadjuk a végére
          return [...prev, item];
        }
      });
    } catch (error) {
      console.error('Error fetching media data:', error);
    }
  };

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotification({
        message: location.state.message,
        type: location.state.type,
      });
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  useEffect(() => {
    fetchCategories();
    fetchMediaData(null);
  }, [token]);

  const handleMediaUpdated = (imageId) => {
    fetchMediaData(imageId); // Refresh media data when an update occurs (e.g., rotation stored)
  };

  return (
    <div>
      <h1>Image Management</h1>
      <Routes>
        <Route path="/" element={<Navigate to="list" />} />
        <Route path="list" element={<ListMedia />} />
        <Route path="upload" element={<UploadMedia />} />
        <Route path="delete" element={<DeleteMedia />} />
        <Route path="assign" element={<AssignCategory />} />
        <Route path="view/:id" element={<ImageViewer categories={categories} data={mediaData} onMediaUpdated={(imageId) => handleMediaUpdated(imageId)} />} />
      </Routes>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default ImageManagement;
